<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="mobileHeader">
      <p>
        <span>出库单号：{{ list.outboundNo }}</span>
        <span>参考单号：{{ list.orgOutboundNo }}</span>
      </p>
      <p>
        <span>预发箱数：{{ list.boxCount }}</span>
        <span>入库箱数：{{ list.inStockCount }}</span>
      </p>
      <p>
        <span>预计发货：{{ list.deliveryDate }}</span>
        <span>已拣箱数：{{ list.pickCount }}</span>
      </p>
    </div>
    <div class="bale-scroll-container">
      <ul class="bale-container">
        <li>
          <div>托唛号</div>
          <div>库位</div>
          <div>箱数</div>
        </li>
        <template v-if="list.tfPalletInfos.length">
          <li v-for="(item, index) in list.tfPalletInfos" :key="index">
            <div>{{ item.palletNo }}</div>
            <div>{{ item.storages }}</div>
            <div>{{ item.boxCount}}</div>
          </li>
        </template>
        <template v-else>
          <van-empty image="search" description="扫描完成" />
        </template>
      </ul>
    </div>
    <div class="sign-item">

      <div class="signInDetail-btnBox">
        <div class="scanBox">
          <van-field
            size="small"
            v-model="list.scanCode"
            placeholder="托唛扫描下架"
            right-icon="scan"
            @click-right-icon="scanDoc"
            @keyup.13="pickOut()"
            @focus="codeFocus"
            ref="scanCode"
          />

          <div class="toSearch-box">
            <button class="sign-toSearch" @click="pickOut()">下架</button>
          </div>
        </div>
      </div>

      <div class="photo">
        <p class="p-title" style="border-bottom: 1px solid #ececec">出库照片</p>
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <ul v-for="(item, i) in photoList" :key="i">
              <div v-for="(item2, i2) in item" :key="i2">
                <p>
                  <span class="red" v-if="item2.required">*</span
                  >{{ item2.text }}
                </p>
                <div class="sign-photo-item" v-if="imgObj[item2.name]">
                  <span class="delete-icon" @click="deleteImg(item2.name)"
                    >x</span
                  >
                  <img
                    :src="imgObj[item2.name]"
                    class="sign-photo-item-img"
                    alt=""
                    @click="previewImage(imgObj[item2.name])"
                  />
                </div>

                <div class="sign-photo-btn" v-else>
                  <div class="photo">
                    <input
                      class="img hidden"
                      @change="changeImg"
                      type="file"
                      name="cover"
                      ref="inputer"
                      accept="image/*"
                      capture="camera"
                    />
                    <p @click="chooseImage(item2.id)">
                      <i class="el-icon-camera"></i>
                    </p>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="avgInfo">
        <van-field
          style="margin-right: 10px"
          v-model="carInStoreTime"
          name="carInStoreTime"
          :readonly="true"
          placeholder="柜车到场时间"
          @click="() => carTimeClick('inStore')"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="overCarTime"
          name="overCarTime"
          :readonly="true"
          placeholder="封柜时间"
          @click="() => carTimeClick('carOver')"
          :rules="[{ required: true }]"
        />
      </div>

       <div class="signInDetail-receipt-main">
        <button class="signInDetail-receipt clear-btn" @click="submit(0)">保存草稿</button>
        <button class="signInDetail-receipt" @click="submit(1)">确认提交</button>
      </div>
    </div>

    <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
    <van-datetime-picker
            v-if="showTime"
            type="time"
            title="选择时间"
            :show-toolbar="true"
            :min-date="minDate"
            :max-date="maxDate"
            :value="currentTime"
            @confirm="onConfirmTimeSelect"
            @cancel="onCancelTimeSelect"
            confirm-button-text="确认"
            cancel-button-text="取消"
            class="picker"
          />
  </div>
</template>

<script>
// 在导入语句中添加Empty组件
import { Field, Toast, Popup, Picker, ImagePreview, Empty, DatetimePicker } from "vant";
import util from "util/date";
import {
  getOutbound,
  submitPick,
  pickOut,
} from "@/api/mobile/jy-outboundPick_api";
import {
  OutboundScanSubmit
} from "@/api/mobile/jy-outbound_api";
import { mixins } from "../mobileMixins";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
export default {
  data() {
    return {
      list: {deliveryOrders: []},
      itemArr: ["本次签收数量"],
      showPicker: false,
      columns: [],
      containTailDisabled: false,
      loading: false,
      viewportHeight: 0,
      focusType: "",
       currentTime: "",
      showTime: false,
      curTransportType:"",
      skuImg: [],
      saveImgUrlArr: [],
      imgFiles: [],
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      photoList: [
        [
          {
            name: "img1",
            text: "车牌照",
            id: 1,
            required: false,
          },
          {
            name: "img2",
            text: "空柜照",
            id: 2,
            required: false,
          },
          {
            name: "img3",
            text: "托运单",
            id: 3,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "未关门照",
            id: 4,
            required: false,
          },
          {
            name: "img5",
            text: "半关门照",
            id: 5,
            required: false,
          },
          {
            name: "img6",
            text: "关门照",
            id: 6,
            required: false,
          },
        ],
        [
          {
            name: "img7",
            text: "锁封照",
            id: 7,
            required: false,
          },
          {
            name: "img8",
            text: "其他",
            id: 8,
            required: false,
          },
          {
            name: "img9",
            text: "其他1",
            id: 9,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      saveImgUrlArr: [],
      inpType: "",
      minDate: new Date(2020, 0, 1), // 最小日期
      maxDate: new Date(2025, 11, 31), // 最大日期
      carInStoreTime: "",
      overCarTime: "",
    };
  },

  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [ImagePreview.name]: ImagePreview,
    // 添加Empty组件注册
    [Empty.name]: Empty,
    [DatetimePicker.name]: DatetimePicker
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    onConfirmTimeSelect(date) {
      console.info(date);
      this.showTime = false;
      if (this.timeType == "inStore") {
        this.carInStoreTime = "柜车到场 " + date;
      } else {
        this.overCarTime = "封柜时间 " + date;
      }
    },
    onCancelTimeSelect() {
      this.showTime = false;
    },
    carTimeClick(timeType) {
      this.getCurrentTime();
      this.timeType = timeType;
      this.showTime = true;
    },
     getCurrentTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      this.currentTime = `${hours}:${minutes}`;
    },
    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      
      if (!img) {
        console.error("未找到图片输入框");
        Toast.fail("系统错误：未找到图片输入框");
        return;
      }

      if (!img.files || !img.files.length) {
        console.log("没有选择文件");
        return;
      }

      console.log("选择的文件:", img.files[0].name, "类型:", img.files[0].type);

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.submitImg();
    },

    chooseImage(num) {
      this.currentImg = num;
      const input = document.getElementsByClassName("img")[0];
      if (!input) {
        Toast.fail("未找到文件输入框");
        return;
      }
      input.value = "";
      
      // 尝试多种方式触发文件选择
      try {
        // 方式1: 直接点击
        input.click();
      } catch (e) {
        console.error("点击失败:", e);
        // 方式2: 创建并触发事件
          try {
            const event = new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window
            });
            input.dispatchEvent(event);
          } catch (e2) {
            console.error("事件触发失败:", e2);
            Toast.fail("无法打开相机，请检查权限设置");
          }
      }
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: this.currentImg,
          });
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    pickOut() {
      const that = this;
      console.info(this.list.scanCode);
      if (this.list.scanCode == undefined) {
        this.showsound(false);
        Toast.fail("请输入或扫描单号");
        return;
      }
      const { tfOutboundID } = this.list;
      const data = {
        TFOutboundID: tfOutboundID,
        ScanCode: this.list.scanCode,
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      pickOut(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success("操作成功");
          setTimeout(() => {
            that.getOutbound();
          }, 500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }

        // 使用 $nextTick 确保 DOM 更新后再执行选择
        this.$nextTick(() => {
          // 直接访问 input 元素并选择文本
          const input = this.$refs.scanCode.$el.querySelector("input");
          if (input) {
            input.select(); // 选择文本
          }
        });
      });
    },
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "locationCode", a.resultStr);
        },
      });
    },
    onConfirm(val) {
      this.$set(this.list, "locationCode", val);
      this.showPicker = false;
    },
    init() {
      const that = this;
      window.addEventListener(
        "resize",
        function () {
          if (that.viewportHeight - this.innerHeight > 50) {
            // 键盘弹起
            if (that.focusType === "locationCode") {
              that.showPicker = false;
            }
            const activeElement = document.activeElement;
            if (
              activeElement.tagName === "INPUT" ||
              activeElement.tagName === "TEXTAREA"
            ) {
              that.$nextTick(function () {
                that.$refs.storage.focus
                  ? (that.$refs.storage.scrollTop = 100)
                  : (that.$refs.boxCount.scrollTop = 100);
              });
            }
          } else {
            // 键盘收起
            if (that.focusType === "locationCode") {
              that.showPicker = true;
            }
          }
        },
        true
      );
      this.getOutbound();
      this.handleImgRequired();
    },
    handleImgRequired() {
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          this.$set(this.photoList[i][i2], "required", false);
          if (this.curTransportType == "空运" && [1, 7].includes(item2.id)) {
            this.$set(this.photoList[i][i2], "required", true);
          }
          if (
            (this.curTransportType == "海运" || this.curTransportType == "") &&
            [1, 2, 6, 7].includes(item2.id)
          ) {
            this.$set(this.photoList[i][i2], "required", true);
          }
        });
      });
    },
    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "locationCode";
    },
    //单据号获取焦点
    codeFocus() {
      this.showPicker = false;
    },

    
    scan() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "locationCode", a.resultStr);
        },
      });
    },
    scanDoc() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "scanCode", a.resultStr);
        },
      });
    },
    getOutbound() {
      const { outboundNo } = this.$route.query;
      const data = {
        outboundNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getOutbound(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.deliveryDate = util.formatDate.format(
              new Date(response.deliveryDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = response;
          this.curTransportType = response.transportType;
          this.carInStoreTime=response.carInStoreTime==null?"":this.extractedTime("柜车到场",response.carInStoreTime);
          this.overCarTime=response.overCarTime==null?"":this.extractedTime("封柜时间",response.overCarTime);
          if (response.imgUrlList && response.imgUrlList.length) {
            response.imgUrlList.forEach((item, i) => {
              this.$set(
                this.imgObj,
                `img${item.labelingType}`,
                `data:image/jpg;base64,${item.urlPath}`
              );
              this.saveImgUrlArr.push({
                imageUrl: item.imgUrl,
                imageType: item.labelingType,
              });
            });
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    extractedTime(type,changeTime) {
      console.info(changeTime);
      const date = new Date(changeTime);
      const hours = String(date.getHours()).padStart(2, '0');
      console.info(hours);
      const minutes = String(date.getMinutes()).padStart(2, '0');
      console.info(minutes);
      return `${type} ${hours}:${minutes}`;
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    checkPhoto(subType) {
      const that = this;

      if (!this.saveImgUrlArr.length && subType == 1) {
        this.showsound(false);
        Toast("请上传照片");
        return false;
      }
      // 定义字符串变量用于存储缺失的必填照片类型名称
      let missingRequiredPhotoNames = [];
      
      let flag = false;
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          let arr = [];
          this.saveImgUrlArr.forEach((item3, i) => {
            arr.push(item3.imageType);
          });
          if (item2.required && !arr.includes(item2.id)) {
            flag = true;
            // 将缺失的必填照片名称添加到字符串中
            missingRequiredPhotoNames.push(item2.text);
          }
        });
      });

      if (flag && subType == 1) {
        this.showsound(false);
        // 使用定义的字符串拼接提示信息
        this.$message({
          message: `请重新上传${missingRequiredPhotoNames.join('、')}`,
          type: "error",
        });
        return false;
      }

      return true;
    },
    submit(subType) {
       //0草稿1提交
      const that = this;

      if (!this.checkPhoto(subType)) return;

      if(subType==1)
      {
        if (this.list.tfPalletInfos.length > 0) {
        this.showsound(false);
        return Toast.fail("还剩托唛未扫描");
      }
      }

      const { tfOutboundID } = this.list;
      const data = {
        tfOutboundID: tfOutboundID,
        imageUrls: this.saveImgUrlArr,
        subType: subType,
        carInStoreTime:this.carInStoreTime,
        overCarTime:this.overCarTime
      };

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
      });

      OutboundScanSubmit(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          this.showsound(true);
          Toast.success("保存成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.red{
  color: red;
}
.signInDetail .mobileHeader {
  padding: 0 10px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;

  > p {
    display: flex;

    > span {
      flex: 1;
    }
  }
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.sign-item {
  background-color: #fbf9fe;
  .signInDetail-content {
    font-size: 15px;
  }

  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      align-items: baseline;
      padding: 5px 10px 2px 1px;
      width: 95%;
      font-size: 14px;
    }

    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    .van-cell {
      margin-left: 10px;
      border: 1px solid #adadad;
      flex: 1;
    }
  }
}
.scanBox{
  display:flex;
  padding:10px;
}
.toSearch-box {
  margin-left: 3%;
  min-height: inherit;
}
.sign-toSearch {
  height: 100%;
  width: 100%;
  border-radius: 5px;
    background-color: #169bd5;
    color: #fff;
}
.avgInfo {
  padding: 2px 10px;
  display: flex;
}
.signInDetail-receipt-main {
  padding: 0px 10px 15px;
}
.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border: 0;
}

.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        position: relative;
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}

.hidden {
  display: none;
}
.bale-scroll-container {
  height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 10px;
  border-radius: 5px;
}
.bale-container li {
  display: flex;
  line-height: 40px;
  font-size: 14px;
  & > div {
    flex: 0.5;
    text-align: center;
  }
  & > div:first-child {
    flex: 1;
  }
}

.putC_footer {
  margin-top: 10px;
  padding: 0 3%;
}

.submit-btn {
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 15px;
  border: 0;
  margin-bottom: 15px;
}

.clear-btn {
  background-color: #cccccc;
}
.unSend-btn {
  background-color: #f02222;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  ul {
    display: flex;
    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        font-size: 13px;
      }
    }
    .sign-photo-item {
      width: 100px;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 100px;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.scanBox {
  display: flex;
  padding: 10px;
  margin-bottom: -15px;
}
.scan-sum {
  padding-left: 20px;
  margin-bottom: -15px;
}
.toSearch-box {
  margin-left: 3%;
  width: 200px;
}
.sign-to {
  height: 80%;
  width: 100%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  border: 0;
}
.sign-to-no {
  height: 80%;
  width: 100%;
  border-radius: 5px;
  background-color: #ec808d;
  color: #fff;
  border: 0;
}
.sign-photo-save {
  padding: 20px 10px;
}
@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>
